import { ZervantSettingsValues } from '@features/invoicingSettings/types/zervantSettingsValues'
import { getPrimaryTradeName } from '@features/invoicingSettings/utils/getPrimaryTradeName'

type GetInvoicesStepSettingsPayloadProps = {
  legalStatus?: string
  logo?: { fileId: string; url: string } | null
  zervantSetting: ZervantSettingsValues
}

export const getInvoicesStepSettingsPayload = ({
  legalStatus,
  logo,
  zervantSetting,
}: GetInvoicesStepSettingsPayloadProps): ZervantSettingsValues => {
  const primaryTradeName = getPrimaryTradeName(zervantSetting.company.tradeNames)

  return {
    ...zervantSetting,
    company: {
      ...zervantSetting.company,
      ...(logo
        ? {
            tradeNames: zervantSetting.company.tradeNames.map((tradeName) =>
              tradeName === primaryTradeName
                ? { ...tradeName, logo: { content: logo.url, id: logo.fileId } }
                : tradeName,
            ),
          }
        : {}),
      legalStatus,
    },
  }
}
